<template>
  <div class="case-creation__step case-creation__billing-information">
    <div class="case-creation__card">
      <div class="case-creation__heading edit-view">
        <div class="title-with-icon">
          <span class="icon">
            <img
              src="@/assets/images/icons/icon-billing-info.svg"
              alt="icon"
              class="img-fluid"
            />
          </span>
          <h3 class="title">Billing Information</h3>
        </div>
      </div>
      <div class="case-creation__body pt-5">
        <div class="case-creation__tabs billing-information-tabs vue-tabs">
          <el-tabs v-model="activeName">
            <el-tab-pane label="PRIMARY INSURANCE" name="first">
              <div id="primary-insurance" v-if="activeName === 'first'">
                <div class="primary-insurance-view">
                  <div class="step-inner-navbar"></div>

                  <div class="step-inner-content">
                    <div class="vue-form">
                      <el-form>
                        <el-row :gutter="15">
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Relationship</h4>
                              <p class="value" v-if="getBillingInformation &&getBillingInformation.relationship">
                                {{ getBillingInformation.relationship }}
                              </p>
                              <p class="value" v-else>--</p>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Plan Type</h4>
                              <span class="value" v-if="getBillingInformation && getBillingInformation.plan_type">
                                {{
                                getBillingInformation.plan_type
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">First Name</h4>
                              <span class="value" v-if="getBillingInformation && getBillingInformation.first_name">
                                {{
                                  convertToUppercase(
                                    getsinglePatientDetails.billing_info
                                      .insurance.primary_insurance.first_name
                                  )
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Middle Name</h4>
                              <span class="value" v-if="getBillingInformation && getBillingInformation.middle_name">
                                {{
                                  convertToUppercase(
                                    getsinglePatientDetails.billing_info
                                      .insurance.primary_insurance.middle_name
                                  )
                                }}
                              </span>
                              <span class="value" v-else> --</span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Last Name</h4>
                              <span class="value" v-if="getBillingInformation && getBillingInformation.last_name">
                                {{
                                  convertToUppercase(
                                    getsinglePatientDetails.billing_info
                                      .insurance.primary_insurance.last_name
                                  )
                                }}
                              </span>
                              <span class="value" v-else> --</span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Gender</h4>
                              <span class="value" v-if="getBillingInformation && getBillingInformation.gender">
                                {{
                                  getBillingInformation.gender
                                }}
                              </span>
                              <span class="value" v-else> --</span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Date of Birth</h4>
                              <span class="value" v-if="getBillingInformation && getBillingInformation.date_of_birth">
                                {{
                                  formatDate(getBillingInformation.date_of_birth
                                  )
                                }}
                              </span>
                              <span class="value" v-else> --</span>
                            </div>
                          </el-col>

                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Insurance Name</h4>
                              <span class="value" v-if="getBillingInformation && getBillingInformation.payor">
                                {{
                                  getBillingInformation.payor
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Policy No</h4>
                              <span class="value" v-if="getBillingInformation && getBillingInformation.policy_id">
                                {{
                                  getBillingInformation.policy_id
                                }}
                              </span>
                              <span class="value" v-else> --</span>
                            </div>
                          </el-col>

                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Group#</h4>
                              <span class="value" v-if="getBillingInformation && getBillingInformation.group">
                                {{
                                  getBillingInformation.group
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>

                          <el-col :xl="6" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Address Line 1</h4>
                              <span class="value" v-if="getBillingInformation && getBillingInformation.address_line_1">
                                {{
                                  getBillingInformation.address_line_1
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Address Line 2</h4>
                              <span class="value" v-if="getBillingInformation && getBillingInformation.address_line_2">
                                {{
                                  getBillingInformation.address_line_2
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Zip</h4>
                              <span class="value" v-if="getBillingInformation && getBillingInformation.zip">
                                {{
                                  getBillingInformation.zip
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>

                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">State</h4>
                              <span class="value" v-if="getBillingInformation && getBillingInformation.state">
                                {{
                                  getBillingInformation.state
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">City</h4>
                              <span class="value" v-if="getBillingInformation && getBillingInformation.city">
                                {{
                                  getBillingInformation.city
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                        </el-row>
                      </el-form>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="SECONDARY INSURANCE" name="second">
              <div id="secondary-insurance" v-if="activeName === 'second'">
                <div class="secondary-insurance-view">
                  <div class="step-inner-navbar"></div>

                  <div class="step-inner-content">
                    <div class="vue-form">
                      <el-form>
                        <el-row :gutter="15">
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Relationship</h4>
                              <span class="value" v-if="getSecondaryInsurance && getSecondaryInsurance.relationship">
                                {{
                                  getSecondaryInsurance.relationship
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Plan Type</h4>
                              <span class="value" v-if="getSecondaryInsurance && getSecondaryInsurance.plan_type">
                                {{
                                  getSecondaryInsurance.plan_type
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">First Name</h4>
                              <span class="value" v-if="getSecondaryInsurance && getSecondaryInsurance.first_name">
                                {{
                                  convertToUppercase(
                                    getsinglePatientDetails.billing_info
                                      .insurance.secondary_insurance.first_name
                                  )
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Middle Name</h4>
                              <span class="value" v-if="getSecondaryInsurance && getSecondaryInsurance.middle_name">
                                {{
                                  convertToUppercase(
                                    getsinglePatientDetails.billing_info
                                      .insurance.secondary_insurance.middle_name
                                  )
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Last Name</h4>
                              <span class="value" v-if="getSecondaryInsurance && getSecondaryInsurance.last_name">
                                {{
                                  convertToUppercase(
                                    getsinglePatientDetails.billing_info
                                      .insurance.secondary_insurance.last_name
                                  )
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Gender</h4>
                              <span class="value" v-if="getSecondaryInsurance && getSecondaryInsurance.gender">
                                {{
                                  getSecondaryInsurance.gender
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Date of Birth</h4>
                              <span class="value" v-if="getSecondaryInsurance && getSecondaryInsurance.date_of_birth">
                                {{
                                  formatDate(
                                    getSecondaryInsurance.date_of_birth
                                  )
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>

                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Insurance Name</h4>
                              <span class="value" v-if="getSecondaryInsurance && getSecondaryInsurance.payor">
                                {{
                                  getSecondaryInsurance.payor
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Policy No</h4>
                              <span class="value" v-if="getSecondaryInsurance && getSecondaryInsurance.policy_id">
                                {{
                                  getSecondaryInsurance.policy_id
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>

                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Group#</h4>
                              <span class="value" v-if="getSecondaryInsurance && getSecondaryInsurance.group">
                                {{
                                  getSecondaryInsurance.group
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>

                          <el-col :xl="6" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Address Line 1</h4>
                              <span class="value" v-if="getSecondaryInsurance && getSecondaryInsurance.address_line_1">
                                {{
                                  getSecondaryInsurance.address_line_1
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Address Line 2</h4>
                              <span class="value" v-if="getSecondaryInsurance && getSecondaryInsurance.address_line_2">
                                {{
                                  getSecondaryInsurance.address_line_2
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Zip</h4>
                              <span class="value" v-if="getSecondaryInsurance && getSecondaryInsurance.zip">
                                {{
                                  getSecondaryInsurance.zip
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>

                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">State</h4>
                              <span class="value" v-if="getSecondaryInsurance && getSecondaryInsurance.state">
                                {{
                                  getSecondaryInsurance.state
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">City</h4>
                              <span class="value" v-if="getSecondaryInsurance && getSecondaryInsurance.city">
                                {{
                                  getSecondaryInsurance.city
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                        </el-row>
                      </el-form>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="TERTIARY INSURANCE" name="third">
              <div id="tertiary-insurance" v-if="activeName === 'third'">
                <div class="tertiary-insurance-view">
                  <div class="step-inner-navbar"></div>

                  <div class="step-inner-content">
                    <div class="vue-form">
                      <el-form>
                        <el-row :gutter="15">
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Relationship</h4>
                              <span class="value" v-if="getTertiaryInsurance && getTertiaryInsurance.relationship">
                                {{
                                  getTertiaryInsurance.relationship
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Plan Type</h4>
                              <span class="value" v-if="getTertiaryInsurance && getTertiaryInsurance.plan_type">
                                {{
                                  getTertiaryInsurance.plan_type
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">First Name</h4>
                              <span class="value" v-if="getTertiaryInsurance && getTertiaryInsurance.first_name">
                                {{
                                  convertToUppercase(
                                    getsinglePatientDetails.billing_info
                                      .insurance.tertiary_insurance.first_name
                                  )
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Middle Name</h4>
                              <span class="value" v-if="getTertiaryInsurance && getTertiaryInsurance.middle_name">
                                {{
                                  convertToUppercase(
                                    getsinglePatientDetails.billing_info
                                      .insurance.tertiary_insurance.middle_name
                                  )
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Last Name</h4>
                              <span class="value" v-if="getTertiaryInsurance && getTertiaryInsurance.last_name">
                                {{
                                  convertToUppercase(
                                    getsinglePatientDetails.billing_info
                                      .insurance.tertiary_insurance.last_name
                                  )
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Gender</h4>
                              <span class="value" v-if="getTertiaryInsurance && getTertiaryInsurance.gender">
                                {{
                                  getTertiaryInsurance.gender
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Date of Birth</h4>
                              <span class="value" v-if="getTertiaryInsurance && getTertiaryInsurance.date_of_birth">
                                {{
                                  formatDate(
                                    getTertiaryInsurance.date_of_birth
                                  )
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>

                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Insurance Name</h4>
                              <span class="value" v-if="getTertiaryInsurance && getTertiaryInsurance.payor">
                                {{
                                  getTertiaryInsurance.payor
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Policy No</h4>
                              <span class="value" v-if="getTertiaryInsurance && getTertiaryInsurance.policy_id">
                                {{
                                  getTertiaryInsurance.policy_id
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>

                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Group#</h4>
                              <span class="value" v-if="getTertiaryInsurance && getTertiaryInsurance.group">
                                {{
                                  getTertiaryInsurance.group
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>

                          <el-col :xl="6" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Address Line 1</h4>
                              <span class="value" v-if="getTertiaryInsurance && getTertiaryInsurance.address_line_1">
                                {{
                                  getTertiaryInsurance.address_line_1
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Address Line 2</h4>
                              <span class="value" v-if="getTertiaryInsurance && getTertiaryInsurance.address_line_2">
                                {{
                                  getTertiaryInsurance.address_line_2
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">Zip</h4>
                              <span class="value" v-if="getTertiaryInsurance && getTertiaryInsurance.zip">
                                {{
                                  getTertiaryInsurance.zip
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>

                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">State</h4>
                              <span class="value" v-if="getTertiaryInsurance && getTertiaryInsurance.state">
                                {{
                                  getTertiaryInsurance.state
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                            <div
                              class="case-creation__input input-value view-cases"
                            >
                              <h4 class="name">City</h4>
                              <span class="value" v-if="getTertiaryInsurance && getTertiaryInsurance.city">
                                {{
                                  getTertiaryInsurance.city
                                }}
                              </span>
                              <span class="value" v-else> -- </span>
                            </div>
                          </el-col>
                        </el-row>
                      </el-form>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="GUARANTOR INSURANCE" name="fourth">
              <div id="guarantorForm-view" v-if="activeName === 'fourth'">
                <div class="step-inner-navbar"></div>

                <div class="step-inner-content">
                  <div class="vue-form">
                    <el-form>
                      <el-row :gutter="15">
                        <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                          <div
                            class="case-creation__input input-value view-cases"
                          >
                            <h4 class="name">Relationship</h4>
                            <span class="value" v-if="getGuarantor && getGuarantor.relationship">
                              {{
                                getGuarantor.relationship
                              }}
                            </span>
                            <span class="value" v-else> -- </span>
                          </div>
                        </el-col>
                        <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                          <div
                            class="case-creation__input input-value view-cases"
                          >
                            <h4 class="name">First Name</h4>
                            <span class="value" v-if="getGuarantor && getGuarantor.first_name">
                              {{
                                convertToUppercase(
                                  getsinglePatientDetails.billing_info.insurance
                                    .guarantor.first_name
                                )
                              }}
                            </span>
                            <span class="value" v-else> -- </span>
                          </div>
                        </el-col>
                        <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                          <div
                            class="case-creation__input input-value view-cases"
                          >
                            <h4 class="name">Middle Name</h4>
                            <span class="value" v-if="getGuarantor && getGuarantor.middle_name">
                              {{
                                convertToUppercase(
                                  getsinglePatientDetails.billing_info.insurance
                                    .guarantor.middle_name
                                )
                              }}
                            </span>
                            <span class="value" v-else> -- </span>
                          </div>
                        </el-col>
                        <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                          <div
                            class="case-creation__input input-value view-cases"
                          >
                            <h4 class="name">Last Name</h4>
                            <span class="value" v-if="getGuarantor && getGuarantor.last_name">
                              {{
                                convertToUppercase(
                                  getsinglePatientDetails.billing_info.insurance
                                    .guarantor.last_name
                                )
                              }}
                            </span>
                            <span class="value" v-else> -- </span>
                          </div>
                        </el-col>
                        <el-col :xl="6" :lg="4" :md="8" :sm="12" :xs="12">
                          <div
                            class="case-creation__input input-value view-cases"
                          >
                            <h4 class="name">Address Line 1</h4>
                            <span class="value" v-if="getGuarantor && getGuarantor.address_line_1">
                              {{
                                getGuarantor.address_line_1
                              }}
                            </span>
                            <span class="value" v-else> -- </span>
                          </div>
                        </el-col>
                        <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                          <div
                            class="case-creation__input input-value view-cases"
                          >
                            <h4 class="name">Address Line 2</h4>
                            <span class="value" v-if="getGuarantor && getGuarantor.address_line_2">
                              {{
                                getGuarantor.address_line_2
                              }}
                            </span>
                            <span class="value" v-else> -- </span>
                          </div>
                        </el-col>
                        <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                          <div
                            class="case-creation__input input-value view-cases"
                          >
                            <h4 class="name">Zip</h4>
                            <span class="value" v-if="getGuarantor && getGuarantor.zip">
                              {{
                                getGuarantor.zip
                              }}
                            </span>
                            <span class="value" v-else> -- </span>
                          </div>
                        </el-col>
                        <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                          <div
                            class="case-creation__input input-value view-cases"
                          >
                            <h4 class="name">State</h4>
                            <span class="value" v-if="getGuarantor && getGuarantor.state">
                              {{
                                getGuarantor.state
                              }}
                            </span>
                            <span class="value" v-else> -- </span>
                          </div>
                        </el-col>
                        <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                          <div
                            class="case-creation__input input-value view-cases"
                          >
                            <h4 class="name">City</h4>
                            <span class="value" v-if="getGuarantor && getGuarantor.city">
                              {{
                                getGuarantor.city
                              }}
                            </span>
                            <span class="value" v-else> -- </span>
                          </div>
                        </el-col>
                      </el-row>
                    </el-form>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
  <ResonForChange
    v-if="takeReasonDialog"
    v-on:close="takeReasonDialog = false"
    v-on:reasonSubmit="deleteBillingInfo"
    title="Reason for Remove Billing Info"
  ></ResonForChange>
</template>
<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import moment from "moment";
import { defineAsyncComponent } from "vue";
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
export default {
  mixins: [UserPermissionsHelper],
  components: {
    ResonForChange,
  },
  data() {
    return {
      activeName: "first",
      caseId: "",
      takeReasonDialog: false,
    };
  },
  computed: {
    ...mapGetters("pendingCases", [
      "getsinglePatientDetails",
      "getDeleteCaseBillingInfoStatus",
    ]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    getBillingInformation() {
      if (
        this.getsinglePatientDetails &&
        Object.keys(this.getsinglePatientDetails).length > 0 &&
        this.getsinglePatientDetails.billing_info &&
        this.getsinglePatientDetails.billing_info.insurance
      ) {
        return this.getsinglePatientDetails.billing_info.insurance
          .primary_insurance;
      }
      return null;
    },
    getSecondaryInsurance() {
      if (
        this.getsinglePatientDetails &&
        Object.keys(this.getsinglePatientDetails).length > 0 &&
        this.getsinglePatientDetails.billing_info &&
        this.getsinglePatientDetails.billing_info.insurance
      ) {
        return this.getsinglePatientDetails.billing_info.insurance
          .secondary_insurance;
      }
      return null;
    },
    getTertiaryInsurance() {
      if (
        this.getsinglePatientDetails &&
        Object.keys(this.getsinglePatientDetails).length > 0 &&
        this.getsinglePatientDetails.billing_info &&
        this.getsinglePatientDetails.billing_info.insurance
      ) {
        return this.getsinglePatientDetails.billing_info.insurance
          .tertiary_insurance;
      }
      return null;
    },
    getGuarantor() {
      if (
        this.getsinglePatientDetails &&
        Object.keys(this.getsinglePatientDetails).length > 0 &&
        this.getsinglePatientDetails.billing_info &&
        this.getsinglePatientDetails.billing_info.insurance
      ) {
        return this.getsinglePatientDetails.billing_info.insurance.guarantor;
      }
      return null;
    },
  },
  methods: {
    deleteReason() {
      this.takeReasonDialog = true;
    },
    goToEditForm() {
      this.$router.push({
        name: "PendingCasesEdit",
        params: { case_id: this.$route.params.case_id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    async deleteBillingInfo() {
      this.caseId = this.$route.params.case_id;
      try {
        this.loading = true;
        await this.$store.dispatch(
          "pendingCases/deleteBillingInfo",
          this.caseId
        );
        if (this.getDeleteCaseBillingInfoStatus) {
          successNotification(
            "Billing Information details cleared successfully"
          );
          window.location.reload();
        } else {
          if (!this.getDeleteCaseBillingInfoStatus)
            errorNotification("Error in clearing Billing Information details");
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss">
.case-creation__billing-information {
  .case-creation__body {
    padding: 0;
  }
  .el-tabs__content {
    padding: 0 20px;
  }
  .el-tabs__nav-scroll {
    padding: 0 20px;
  }
  .right-align {
    display: flex;
  }
  .el-tabs__nav-wrap::after {
    height: 1px;
  }
  .delete-billing-info {
    margin-right: 20px;
    padding: 5px 0;
    button {
      background: #f24a55;
      min-height: 25px;
      border: none;

      padding: 5px 20px;
    }
  }
}
</style>
